import { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { Header } from './components/Header'
import { Welcome } from './components/Welcome'
import { LangProvider } from './lang'
import { Room } from './pages/Room'
import { Start } from './pages/Start'

/* Start und Raum liegen im Hauptbündel: beides ist der Weg vom Scan zur
   Karte. Alles andere kommt nach, wenn es jemand öffnet. */
const Admin = lazy(() => import('./pages/Admin').then((m) => ({ default: m.Admin })))
const Account = lazy(() => import('./pages/Account').then((m) => ({ default: m.Account })))
const BigBoard = lazy(() => import('./pages/BigBoard').then((m) => ({ default: m.BigBoard })))
const CreateRoom = lazy(() => import('./pages/CreateRoom').then((m) => ({ default: m.CreateRoom })))
const GameMaster = lazy(() => import('./pages/GameMaster').then((m) => ({ default: m.GameMaster })))
const Imprint = lazy(() => import('./pages/Legal').then((m) => ({ default: m.Imprint })))
const Privacy = lazy(() => import('./pages/Legal').then((m) => ({ default: m.Privacy })))
const Leaderboard = lazy(() => import('./pages/Leaderboard').then((m) => ({ default: m.Leaderboard })))
const Report = lazy(() => import('./pages/Report').then((m) => ({ default: m.Report })))
const Rules = lazy(() => import('./pages/Rules').then((m) => ({ default: m.Rules })))
const Wall = lazy(() => import('./pages/Wall').then((m) => ({ default: m.Wall })))
const Terms = lazy(() => import('./pages/Terms').then((m) => ({ default: m.Terms })))

export function App() {
  return (
    <LangProvider>
      <Welcome />
      <BrowserRouter>
        <Header />
        <Suspense fallback={<div className="page"><p className="muted">…</p></div>}>
          <Routes>
            <Route path="/" element={<Start />} />
            <Route path="/room/:roomId" element={<Room />} />
            <Route path="/room/:roomId/melden" element={<Report />} />
            <Route path="/room/:roomId/rangliste" element={<Leaderboard />} />
            <Route path="/room/:roomId/spielleiter" element={<GameMaster />} />
            <Route path="/erstellen" element={<CreateRoom />} />
            <Route path="/konto" element={<Account />} />
            <Route path="/verwaltung" element={<Admin />} />
            <Route path="/anmelden" element={<Account />} />
            <Route path="/regeln" element={<Rules />} />
            <Route path="/wand" element={<Wall />} />
            <Route path="/verwaltung/begriffe" element={<Terms />} />
            <Route path="/impressum" element={<Imprint />} />
            <Route path="/datenschutz" element={<Privacy />} />
            <Route path="/board/:slug" element={<BigBoard />} />
            <Route path="*" element={<Start />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    </LangProvider>
  )
}
